import { FC } from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { Close } from '../icons'

interface ModalCloseButtonProps {
  onClick: () => void
  variant?: 'default' | 'light'
}

export const ModalCloseButton: FC<ModalCloseButtonProps> = ({ onClick, variant = 'default' }) => (
  <StyledButton onClick={onClick} $variant={variant}>
    <Close width={24} height={24} color={variant === 'light' ? theme.color.white : theme.color.black} />
  </StyledButton>
)

const StyledButton = styled.button<{ $variant: 'default' | 'light' }>`
  cursor: pointer;
  position: absolute;
  z-index: 999;
  top: ${theme.spacing.mediumLarge}px;
  right: ${theme.spacing.mediumLarge}px;
  border: none;
  background: ${({ $variant }) => ($variant === 'light' ? 'rgba(255, 255, 255, 0.4)' : 'transparent')};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${({ $variant }) => $variant === 'light' && 'rgba(203, 202, 202, 0.6)'};
  }

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    top: ${theme.spacing.small}px;
    right: ${theme.spacing.small}px;
  }
`
